import Loader from '@components/shared/loader/Loader';
import { useSetInitial } from '@hooks/common/UseSetInitial';
import { useDocumentTitle } from '@hooks/DocumentTitle/UseDocumentTitle';
import { useCheckDevice } from '@hooks/UseCheckDevice';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { Header } from '../components/header/Header';
import { SideNav } from '../components/side-nav/SideNav';

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { isMobileDevice } = useCheckDevice();
  useDocumentTitle();
  const loading = useSetInitial();

  if (loading) {
    return <Loader />;
  }

  return (
    <MainLayoutContainer>
      <HeaderContainer>
        <Header />
      </HeaderContainer>
      <Content>
        <SideNavContainer isMobileDevice={isMobileDevice}>
          <SideNav />
        </SideNavContainer>
        <MainContent>{children}</MainContent>
      </Content>
    </MainLayoutContainer>
  );
};

interface SideNavContainerProps {
  isMobileDevice: boolean;
}

const SideNavContainer = styled.div<SideNavContainerProps>`
  flex: 0 0 auto;
  width: ${(props) => (!props.isMobileDevice ? `60px` : ``)};
`;

const MainLayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const HeaderContainer = styled.div`
  flex: 0 0 auto;
  z-index: 200;
`;

const Content = styled.div`
  display: flex;
  flex: 1;
`;

const MainContent = styled.div`
  flex: 1;
  overflow: auto;
`;

export default MainLayout;
